// @flow

const NON_DIGIT_REGEX = /\D/g;
const DIGIT_REGEX = /\d/;
const PERUVIAN_MOBILE_REGEX = /^9\d{8}$/;
const COUNTRY_CALLING_CODE = '51';
const NATIONAL_NUMBER_LENGTH = 9;
const GROUP_SIZE = 3;

export const PHONE_SEPARATOR = ' ';

export function unmaskPhone(value: string): string {
  const digits = value.replace(NON_DIGIT_REGEX, '');
  const national = digits.startsWith(COUNTRY_CALLING_CODE) && digits.length > NATIONAL_NUMBER_LENGTH
    ? digits.slice(COUNTRY_CALLING_CODE.length)
    : digits;

  return national.slice(0, NATIONAL_NUMBER_LENGTH);
}

export function maskPhone(value: string): string {
  const digits = unmaskPhone(value);
  const groups = [];

  for (let index = 0; index < digits.length; index += GROUP_SIZE) {
    groups.push(digits.slice(index, index + GROUP_SIZE));
  }

  return groups.join(PHONE_SEPARATOR);
}

export function isValidPhone(value: string): boolean {
  return PERUVIAN_MOBILE_REGEX.test(unmaskPhone(value));
}

export function countDigits(value: string): number {
  return value.replace(NON_DIGIT_REGEX, '').length;
}

export function caretPositionAfterDigits(maskedValue: string, digitCount: number): number {
  if (digitCount === 0) {
    return 0;
  }

  let seenDigits = 0;

  for (let index = 0; index < maskedValue.length; index += 1) {
    if (DIGIT_REGEX.test(maskedValue[index])) {
      seenDigits += 1;

      if (seenDigits === digitCount) {
        return index + 1;
      }
    }
  }

  return maskedValue.length;
}
